<template>
	<div class="head_box">
		<div class="head_bar">
			<img src="../assets/image/pic_logo@2x.png" alt="" class="icon">
		</div>
		<div class="head_ul">
			<div class="head_li" @click="tab_btn('/','sy',tab_index == 'sy')"><span :class="{'active': tab_index == 'sy'}">首页</span></div>
			<div class="head_li" @click="fl_btn(item)" v-for="(item,index) in fl_list" :key="index"  :class="{'actives': gallyIndex == item.code&&gallFlag}">
				    <span :class="{'active': tab_index == item}">{{item.name}}</span> 
				</div>
			<!-- <div class="head_li">
				<span :class="{'active': tab_index == 'tk'}">图库</span>
				<div class="head_fl">
					<div @click="fl_btn(item)" v-for="(item,index) in fl_list" :key="index" class="head_fl_item " :class="{'actives': gallyIndex == item.code&&gallFlag}">
						{{item.name}}
					</div>
				</div>
			</div> -->
			
			
			<div @click="tab_btn('story_index','tpgs',tab_index == 'tpgs')" class="head_li"><span :class="{'active': tab_index == 'tpgs'}">近似种类</span></div>
			<div @click="tab_btn('chart_index','tltw',tab_index == 'tltw')" class="head_li"><span :class="{'active': tab_index == 'tltw'}">数据集</span></div>
			<!-- <div @click="tab_btn('thanks','zx',tab_index == 'zx')" class="head_li"><span :class="{'active': tab_index == 'zx'}">致谢</span></div> -->
			<div @click="tab_btn('copyright','bqgg'),tab_index == 'bqgg'" class="head_li"><span :class="{'active': tab_index == 'bqgg'}">版权公告</span></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'galleryIndex',
		data() {
			return {
				galleryIndex: 1,
				fl_list: [], // 分类
			}
		},
		computed: {
			gallFlag() {
				if(this.$route.name == 'galleryIndex' || this.$route.name == 'galleryDec' || this.$route.name == 'gallery_describe' || this.$route.name == 'gallery_indexTw' || this.$route.name == 'gallery_decTw'){
					return true
				}else{
					return false
				}
			},
			gallyIndex() {
				return this.$store.state.gallyIndex
			},
			tab_index() {
				console.log(this.$store.state.tabIndex)
				return this.$store.state.tabIndex
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			tab_btn(url,name,flag){
				this.$store.commit('SET_TAB', name)
				// if(flag){
				// 	return
				// }
				this.$router.push({
					path: url
				})
			},
			// 分类
			fl_btn(item) {
				this.$store.commit('SET_TAB', 'tk')
				if (this.$route.name == 'galleryIndex') {
					this.$store.commit('SET_GALY', item.code)
				} else {
					this.$router.push({
						name: 'galleryIndex'
					})
					this.$store.commit('SET_GALY', item.code)
				}
			},
			init() {
				this.$http.get(`/front/gallery/category/home`).then(res => {
					this.fl_list = res.data
					if(!this.$store.state.gallyIndex){
						this.$store.commit('SET_GALY', this.$store.state.gallyIndex)
					}
					this.$store.commit('SET_FL', res.data)
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.head_box {
		position: relative;
		z-index: 9999;
		background: transparent;
		.head_bar{
			//width: 870px;
			//width: 870px;
			width: 1200px;
			padding-top: 28px;
			margin: 0 auto 41px;
			height: 74px;
		}
		.icon {
			height: 74px;
		}

		.head_ul {
			display: flex;
			align-items: center;
			//width: 870px;
			width: 1200px;
			background: #fff;
			margin: 0 auto 23px;

			.head_li {
				width: calc(100% / 6);
				box-sizing: border-box;
				text-align: center;
				position: relative;
				cursor: pointer;
				&::before{
					content: "";
					position: absolute;
					width: 2px;
					height: 30px;
					background: #E5E5E5;
					top: 50%;
					transform: translateY(-50%);
					right: 1px;
				}
				&:last-child{
					&::before{
						content: "";
						display: none;
					}
				}
				

				span {
					font-size: 20px;
					display: inline-block;
					height: 100%;
					line-height: 56px;
					color: #333333;
				}

				.active {
					color: #22AB67;
					position: relative;
					font-weight: bold;

					// &::before {
					// 	content: "";
					// 	position: absolute;
					// 	bottom: 0;
					// 	width: 100%;
					// 	height: 8px;
					// 	background: #22AB67;
					// }
				}

				&:hover {
					span {
						color: #22AB67;
						position: relative;

						// &::before {
						// 	content: "";
						// 	position: absolute;
						// 	bottom: 0;
						// 	width: 100%;
						// 	height: 8px;
						// 	background: #22AB67;
						// }
					}

					.head_fl {
						opacity: 1;
						height: auto;
					}
				}

				.head_fl {
					position: absolute;
					width: 100%;
					height: 0;
					top: 56px;
					opacity: 0;
					left: 0;
					z-index: 9999;
					background: #fff;
					transition: .5s;
					overflow: hidden;

					.head_fl_item {
						display: block;
						height: 46px;
						text-align: center;
						line-height: 46px;
						color: #333333;
						font-size: 15px;
					}

					.actives {
						color: #22AB67;
					}
				}
			}
			
		}
	}
</style>
